import { createContext } from "react";

export const AppContext = createContext(); // eslint-disable-line import/prefer-default-export
